<template>
	<Teleport to="body">
		<Transition name="fade">
			<div v-if="isOpen" class="layout-cover" @click="isOpen = false"></div>
		</Transition>
	</Teleport>
</template>

<script setup lang="ts">
	const isOpen = defineModel<boolean>('isOpen')

	// const isMobile = ref(window.innerWidth < 992)

	// window.addEventListener('resize', () => {
	// 	isMobile.value = window.innerWidth < 992
	// })
</script>

<style scoped lang="scss">
	.layout-cover {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1000;
		width: 100%;
		height: 100%;
		background-color: #00000090;
		backdrop-filter: blur(0.5rem);
	}
</style>
